import "./Pagination.css";

export const Pagination = ({
  filteredItems,
  totalItems,
  startIdx,
  endIdx,
  page,
  setPage,
  totalPages,
}) => {
  const total =
    typeof totalItems === "number"
      ? totalItems
      : Array.isArray(filteredItems)
      ? filteredItems.length
      : 0;

  const goto = (n) => setPage(Math.max(1, Math.min(totalPages, n)));

  return (
    <div className="pagination">
      <span className="pagination-counter">
        {total === 0 ? 0 : startIdx + 1}/{Math.min(endIdx, total)} de {total}
      </span>

      <div className="pagination__buttons">
        <button
          type="button"
          className="pagination-btn pagination-btn--outline"
          disabled={page <= 1}
          onClick={() => goto(page - 1)}
          aria-label="Página anterior"
        >
          {"<"}
        </button>

        <button
          type="button"
          className="pagination-btn pagination-btn--outline"
          disabled={page >= totalPages}
          onClick={() => goto(page + 1)}
          aria-label="Página siguiente"
        >
          {">"}
        </button>
      </div>
    </div>
  );
};

export default Pagination;
